import { useState } from 'react'
import { useResizeObserver } from 'lib/hooks/use-resize-observer'

const headerHeight = 100

export const useFitCardToScreen = ({ cardRef }) => {
  const [isScreenSmall, setIsScreenSmall] = useState(false)

  const { notSupported } = useResizeObserver({
    refToObserve: cardRef,
    onResize: ([entry]) => {
      const { borderBoxSize, contentRect } = entry
      const cardHeight = borderBoxSize
        ? borderBoxSize[0]?.blockSize
        : contentRect?.height
      setIsScreenSmall(cardHeight >= window.innerHeight - headerHeight)
    },
  })

  return isScreenSmall || notSupported
}
